import { useEffect, useState, useRef } from "react";
import InboxService from "../Services/InboxService";
import { useInboxCompose } from "./InboxComposeProvider";
import CreatableSelect from 'react-select/creatable';
import PubSub from 'pubsub-js';

function InboxCompose() {

    const { subject, setSubject } = useInboxCompose();
    const { from, setFrom } = useInboxCompose([]);
    const { to, setTo } = useInboxCompose([]);

    const [body, setBody] = useState('');
    const bodyRef = useRef(null);
    const [loading, setLoading] = useState(false);

    const { isVisible, closeCompose } = useInboxCompose();
    const [accounts, setAccounts] = useState([]);

    useEffect(() => {
        getAccountsWithInbox();
    }, [])

    if (!isVisible) {
        return null;
    }

    function prepareParamsForSendEmail() {

        let fromRecipients = from.map(f => f.value).join(',');
        let toRecipients = to.map(t => t.value).join(',');

        return {
            from: fromRecipients,
            to: toRecipients,
            subject,
            body
        }
    }

    async function sendEmailFromCompose() {

        setLoading(true);
        PubSub.publish('loading.notification', { message: 'Sending email...', show: true });

        let params = prepareParamsForSendEmail();

        let { message } = await InboxService.sendEmail(params);

        PubSub.publish('loading.notification.hide');
        setLoading(false);

        PubSub.publish('show-basic-notification', { title: 'Success', message });

        // Clear fields and close compose
        setSubject('');
        setFrom([]);
        setTo([]);
        setBody('');
        if (bodyRef.current) bodyRef.current.innerHTML = '';
        closeCompose();

    }

    async function getAccountsWithInbox() {
        let accounts = await InboxService.getAccountsInInboxWithNames();
        setAccounts(accounts);
    }

    return (
        <div className="inbox-compose-container">
            <div className="inbox-compose-header">
                New message
                <button
                    data-tooltip-id="inbox-tooltip"
                    data-tooltip-content="Close"
                    onClick={closeCompose}>
                    <i className="fa-solid fa-xmark"></i>
                </button>
            </div>
            <div className="inbox-compose-content">
                {loading && (
                    <div className="loading-overlay">
                        <div className="spinner-container">
                            <i className="fa-solid fa-spin fa-spinner"></i>
                            <span className="loading-text">Sending...</span>
                        </div>
                    </div>
                )}
                <div className="inbox-compose-recipient">
                    <span>From: </span>
                    <CreatableSelect
                        isMulti
                        styles={{
                            flex: 1,
                            control: (styles) => ({ ...styles, backgroundColor: 'white', border: 'none', boxShadow: 'none' }),
                        }}
                        onChange={e => setFrom(e)}
                        defaultValue={[]}
                        placeholder="select an email address"
                        options={accounts.map(({ name, email }) => ({ value: email, label: `${name} - ${email}` }))} />


                </div>
                <div className="inbox-compose-recipient">
                    <span>To: </span>
                    <CreatableSelect
                        isMulti
                        styles={{
                            flex: 1,
                            control: (styles) => ({ ...styles, backgroundColor: 'white', border: 'none', boxShadow: 'none' }),
                        }}
                        onChange={e => setTo(e)}
                        defaultValue={[]}
                        placeholder="select an email address"
                        options={[]} />

                </div>
                <div className="inbox-compose-subject">
                    <input type="text"
                        value={subject}
                        onChange={e => setSubject(e.target.value)}
                        className="inbox-compose-input"
                        placeholder="Subject" />
                </div>
                <div
                    contentEditable="true"
                    ref={bodyRef}
                    onInput={e => setBody(e.target.innerHTML)}
                    className="inbox-compose-body"
                    data-placeholder="Content">
                </div>
                <div>
                    <button
                        onClick={sendEmailFromCompose}
                        disabled={loading}
                        className="inbox-compose-send-button">Send</button>
                </div>
            </div>


        </div>
    )
}

export default InboxCompose;